import React from 'react';
import Markdown, { type Components } from 'react-markdown';
import remarkBreaks from 'remark-breaks';

import { openExternalLink } from '../../telegram/telegram';

const ALLOWED_ELEMENTS = ['p', 'br', 'strong', 'em', 'del', 'code', 'ul', 'ol', 'li', 'a', 'blockquote'];
const REMARK_PLUGINS = [remarkBreaks];

// Bold labels written by the backend MatchingDescriptionBuilder; keep in sync with its level labels.
const LEVEL_CLASSES: Record<string, string> = {
  'Хотят:': 'ttbMdLevel--want',
  'Согласны:': 'ttbMdLevel--acceptable',
  'Не хотят:': 'ttbMdLevel--exclude',
};

const COMPONENTS: Components = {
  strong: ({ children }) => {
    const label = typeof children === 'string' ? children.trim() : '';
    const levelClass = LEVEL_CLASSES[label];
    return <strong className={levelClass ? `ttbMdLevel ${levelClass}` : undefined}>{children}</strong>;
  },
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        if (!href) return;
        e.preventDefault();
        openExternalLink(href);
      }}
    >
      {children}
    </a>
  ),
};

export type MarkdownTextProps = {
  text: string;
};

/** Renders a safe Markdown subset: no raw HTML, no images, no headings. */
export const MarkdownText = React.memo(function MarkdownText({ text }: MarkdownTextProps) {
  return (
    <Markdown
      remarkPlugins={REMARK_PLUGINS}
      allowedElements={ALLOWED_ELEMENTS}
      unwrapDisallowed
      components={COMPONENTS}
    >
      {text}
    </Markdown>
  );
});
